import {
    SET_CURRENT_USER, LOG_OUT, AUTHENTICATE, UPDATE_LOCATION,
    SET_USER, SET_LOCATION, DEFAULT_AGENCY_PROFILE, SET_PERMISSIONS
} from './ActionTypes';
import {clearToken} from './../utils/TokenManager';
import LoginService from './../services/LoginService';
import {getUser, setUser} from "../utils/TokenManager";

export const setCurrentUser = (authData) => ({type: SET_CURRENT_USER, authData});

export const setUserData = (authData) => ({type: SET_USER, authData});

const logOutSuccess = () => ({type: LOG_OUT});

export const authenticateSuccess = (auth) => ({type: AUTHENTICATE, auth});

export const setLocation = (location) => ({type: SET_LOCATION, location});

export const setNewLocationList = (location) => ({type: UPDATE_LOCATION, location});

const defaultAgencyProfileData = (profileId, profile) => ({
    type: DEFAULT_AGENCY_PROFILE, profileId, profile
});

export const logIn = (credentials) => (
    async (dispatch) => {
        try {
            const response = await LoginService.doLogin(credentials);
            if (200 == response.status) {
                await clearToken();

                response.data.user['app-version'] = response.headers['app-version'];
                console.log(response.data);
                console.log(response.data.user);
                
                dispatch(setCurrentUser(response.data.user));
                return true;
            }
        } catch (error) {
            console.log(error);
            throw error;
        }
        return false;
    }
);

export const setChangedLocation = (location) => {
    return (dispatch) => {
        if (!location) {
            let user = getUser();
    
            if (user) {
                location = user.agency_location
            }
        }
        dispatch(setLocation(location));
        dispatch(defaultAgencyProfileData("", {}));
    };
};

export const setLocationList = (location) => {
    if (!location) {
        let user = getUser();

        if (user) {
            location = user.agency_location_list
        }
    } else {
        let user = getUser();
        let newUser = {...user};
        newUser.agency_location_list = location;
        setUser(newUser);
    }

    return (dispatch) => {
        dispatch(setNewLocationList(location));
    };
};

export const logOut = () => 
    async (dispatch) => {
        try {
            await LoginService.logout();
        } catch (error) {
            console.log(error);
        }
        dispatch(logOutSuccess());
        return false;
    };


export const logOutWithoutLogging = () =>
    async (dispatch) => {
        dispatch(logOutSuccess());
        return false;
    };


export const authenticate = (auth) =>
    (dispatch) => {
        dispatch(authenticateSuccess(auth));
    };

export const getPermissions = (userId) => (
    async (dispatch) => {
        try {
            const response = await LoginService.getPermissions(userId);
            if (200 == response.status) {
                dispatch({type: SET_PERMISSIONS, permissions: response.data});
                return true;
            }
        } catch (error) {
            console.log(error);
            throw error;
        }
        return false;
    }
);



// WEBPACK FOOTER //
// ./src/actions/AuthAction.js